import { render, staticRenderFns } from "./UploadAlbumNumbers.vue?vue&type=template&id=013f9089&scoped=true"
import script from "./UploadAlbumNumbers.vue?vue&type=script&lang=js"
export * from "./UploadAlbumNumbers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "013f9089",
  null
  
)

export default component.exports